import { getViewsByParent } from '../BaseTabsRouting/utils';

import { Header } from '../BaseTabsRouting/types';
import Contacts from './Contacts/Contacts';
import DatabaseView from './DatabaseView/DatabaseView';
import DeployHistory from './DeployHistory/DeployHistory';
import TenantSettings from './TenantSettings/TenantSettings';
import { PushNotifications } from './PushNotifications/PushNotifications';
import RegionalPool from './RegionalPool/RegionalPool';
import BaseProfile from './BaseProfile/BaseProfile';
import { MailAndSMS } from './MailAndSMS/MailAndSMS';
import TravelCostSettings from './Admin/TravelCostSettings/TravelCostSettings';
import DutyExchange from './DutyExchange/DutyExchange';
import { ImportHoursBalance } from './ImportHoursBalance/ImportHoursBalance';
import { ImportTravelArrangement } from './ImportTravelArrangement/ImportTravelArrangement';
import { AbsenceImport } from './AbsenceImport/AbsenceImport';
import WorkPattern from './WorkPattern/WorkPattern';
import RosterSettings from './Admin/RosterSettings/RosterSettings';
import { UploadFile } from './UploadFile/UploadFile';
import HourManagement from './Roster/HourManagement/HourManagement';
import ActivityPlanning from './ActivityPlanning/ActivityPlanning';
import Absence from './Roster/Absence/Absence';
import MatchSettings from './Match/MatchSettings';
import UserAndPassword from './UserAndPassword/UserAndPassword';
import EmployeeSettings from './EmployeeSettings/EmployeeSettings';
import AIMatchSettings from './AIMatch/AIMatch';
import Configurations from './Configurations/Configurations';

export enum MenusOptions {
  SETTINGS_ADMIN = 'admin',
  SETTINGS_ROSTER = 'roster',
  SETTINGS_IMPORT = 'import',
  REGIONAL_POOL = 'regional_pool',
  CONTACTS = 'contacts',
  DEPLOY_HISTORY = 'deploy_history',
  AI_MATCH = 'ai_match',
  CONFIGURATIONS = 'configurations'
}

export const settingsViews = [
  {
    id: 280,
    name: 'TENANT_SETTINGS',
    Component: TenantSettings,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 300,
    name: 'USER_AND_PASSWORD',
    Component: UserAndPassword,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 320,
    name: 'TRAVEL_SETTINGS',
    Component: TravelCostSettings,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 340,
    name: 'DATABASE_VIEW',
    Component: DatabaseView,
    parent: MenusOptions.SETTINGS_ADMIN,
    requiredGrants: ['hasDatabaseViewAccess']
  },
  {
    id: 360,
    name: 'PUSH_NOTIFICATION',
    Component: PushNotifications,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 380,
    name: 'ROSTER_SETTINGS',
    Component: RosterSettings,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 400,
    name: 'MAIL_AND_SMS',
    Component: MailAndSMS,
    parent: MenusOptions.SETTINGS_ADMIN
  },
  {
    id: 420,
    name: 'ABSENCE',
    Component: Absence,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 440,
    name: 'BASE_PROFILE',
    Component: BaseProfile,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 460,
    name: 'DUTY_EXCHANGE',
    Component: DutyExchange,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 480,
    name: 'HOURMANAGEMENT',
    Component: HourManagement,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 500,
    name: 'WORK_PATTERN',
    Component: WorkPattern,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 520,
    name: 'ACTIVITY_PLANNING',
    Component: ActivityPlanning,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 540,
    name: 'MATCH_SETTINGS',
    Component: MatchSettings,
    parent: MenusOptions.SETTINGS_ROSTER
  },
  {
    id: 580,
    name: 'EMPLOYEE_SETTINGS',
    Component: EmployeeSettings,
    parent: MenusOptions.SETTINGS_IMPORT
  },
  {
    id: 600,
    name: 'ARRANGEMENTS_SETTINGS',
    Component: ImportTravelArrangement,
    parent: MenusOptions.SETTINGS_IMPORT
  },
  {
    id: 620,
    name: 'ABSENCE_SETTINGS',
    Component: AbsenceImport,
    parent: MenusOptions.SETTINGS_IMPORT
  },
  {
    id: 640,
    name: 'HOURS_BALANCE',
    Component: ImportHoursBalance,
    parent: MenusOptions.SETTINGS_IMPORT
  },
  {
    id: 660,
    name: 'UPLOAD_FILE',
    Component: UploadFile,
    parent: MenusOptions.SETTINGS_IMPORT
  },
  {
    id: 680,
    name: 'REGIONAL_POOL',
    Component: RegionalPool,
    parent: MenusOptions.REGIONAL_POOL
  },
  {
    id: 700,
    name: 'CONTACTS',
    Component: Contacts,
    parent: MenusOptions.CONTACTS
  },
  {
    id: 720,
    name: 'DEPLOY_HISTORY',
    Component: DeployHistory,
    parent: MenusOptions.DEPLOY_HISTORY
  },
  {
    id: 740,
    name: 'AI_MATCH',
    Component: AIMatchSettings,
    parent: MenusOptions.AI_MATCH
  },
  {
    id: 760,
    name: 'CONFIGURATIONS',
    Component: Configurations,
    parent: MenusOptions.CONFIGURATIONS
  }
];

export const settingsHeaders: Header[] = [
  {
    subHeaderName: MenusOptions.SETTINGS_ADMIN,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.SETTINGS_ADMIN
    )
  },
  {
    subHeaderName: MenusOptions.SETTINGS_ROSTER,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.SETTINGS_ROSTER
    )
  },
  {
    subHeaderName: MenusOptions.SETTINGS_IMPORT,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.SETTINGS_IMPORT
    )
  },
  {
    subHeaderName: MenusOptions.REGIONAL_POOL,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.REGIONAL_POOL
    )
  },
  {
    subHeaderName: MenusOptions.CONTACTS,
    tabs: getViewsByParent<MenusOptions>(settingsViews, MenusOptions.CONTACTS)
  },
  {
    subHeaderName: MenusOptions.DEPLOY_HISTORY,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.DEPLOY_HISTORY
    )
  },
  {
    subHeaderName: MenusOptions.AI_MATCH,
    tabs: getViewsByParent<MenusOptions>(settingsViews, MenusOptions.AI_MATCH),
    requiredGrants: ['hasAutoAskDutyRoundsViewAccess']
  },
  {
    subHeaderName: MenusOptions.CONFIGURATIONS,
    tabs: getViewsByParent<MenusOptions>(
      settingsViews,
      MenusOptions.CONFIGURATIONS
    ),
    requiredGrants: ['hasConfigurations']
  }
];
